import { Component, Inject, OnInit } from '@angular/core'
import { FormBuilder, FormGroup } from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { takeUntil } from 'rxjs'

import { DevicesService } from '@app/shared/modules/devices/devices.service'
import { DestroyService } from '@app/core/services/destroy.service'

import { Dayjs } from 'dayjs'
import { DeviceOwnership, DeviceOwnershipLabel } from '@app/shared/models/device.model'

@Component({
  selector: 'lin-bulk-update-dialog',
  templateUrl: './bulk-update-dialog.component.html',
  styleUrls: ['./bulk-update-dialog.component.scss'],
  providers: [DestroyService],
  standalone: false,
})
export class BulkUpdateDialogComponent implements OnInit {
  form: FormGroup
  isSubmitting = false

  DeviceOwnershipLabel = DeviceOwnershipLabel

  get devicesCount(): number {
    return this.data.devices.size
  }

  get isContractMode(): boolean {
    return this.data.mode === 'contract'
  }

  constructor(
    private readonly dialogRef: MatDialogRef<BulkUpdateDialogComponent>,
    private readonly fb: FormBuilder,
    private readonly devicesService: DevicesService,
    private readonly destroyService: DestroyService,
    @Inject(MAT_DIALOG_DATA) private readonly data: { devices: Map<string, string>; mode: 'contract' | 'ownership' },
  ) {}

  ngOnInit(): void {
    this.isContractMode ? this.initContractForm() : this.initOwnershipForm()
    !this.isContractMode && this.form.markAsDirty()
  }

  private initContractForm(): void {
    this.form = this.fb.group({
      contractId: '',
      contractStartAt: '',
      contractFinishAt: '',
    })
  }

  private initOwnershipForm(): void {
    this.form = this.fb.group({
      ownership: DeviceOwnership.Linxio,
    })
  }

  updateDevicesContract(): void {
    const formData = this.form.value as { contractId: string; contractStartAt: Dayjs; contractFinishAt: Dayjs }
    const data = {
      contractId: formData.contractId,
      contractStartAt: formData.contractStartAt ? formData.contractStartAt.tz().format() : null,
      contractFinishAt: formData.contractFinishAt ? formData.contractFinishAt.tz().format() : null,
    }

    this.isSubmitting = true

    this.devicesService
      .updateDevicesContract(<string[]>[...this.data.devices.keys()], data)
      .pipe(takeUntil(this.destroyService))
      .subscribe(() => {
        this.isSubmitting = false
        this.dialogRef.close(true)
      })
  }

  updateDevicesOwnership(): void {
    const data = { ownership: <string>this.form.get('ownership').value }
    this.isSubmitting = true

    this.devicesService
      .updateDevicesOwnership(<string[]>[...this.data.devices.keys()], data)
      .pipe(takeUntil(this.destroyService))
      .subscribe(() => {
        this.isSubmitting = false
        this.dialogRef.close(true)
      })
  }
}
